"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeWeight = exports.TypeDecoration = exports.MotionEasing = void 0;
var MotionEasing;
(function (MotionEasing) {
    MotionEasing["EASE_IN_OUT"] = "easeInOut";
    MotionEasing["EASE_OUT"] = "easeOut";
    MotionEasing["EASE_IN"] = "easeIn";
    MotionEasing["EASE"] = "ease";
    MotionEasing["LINEAR"] = "linear";
})(MotionEasing = exports.MotionEasing || (exports.MotionEasing = {}));
var TypeDecoration;
(function (TypeDecoration) {
    TypeDecoration["UNDERLINE"] = "underline";
    TypeDecoration["LINE_THROUGH"] = "line-through";
    TypeDecoration["NONE"] = "none";
})(TypeDecoration = exports.TypeDecoration || (exports.TypeDecoration = {}));
var TypeWeight;
(function (TypeWeight) {
    TypeWeight["light"] = "light";
    TypeWeight["regular"] = "regular";
    TypeWeight["medium"] = "medium";
    TypeWeight["bold"] = "bold";
})(TypeWeight = exports.TypeWeight || (exports.TypeWeight = {}));
//# sourceMappingURL=token-value.js.map